<template>
    <form @submit.prevent="save" id="formHealthGuideSurvey">

        <div v-if="Error" class="alert alert-danger" v-html="Error"></div>

        <div class="row form-group">
            <div class="col-12">
                <label>How much will power do you have?</label>
                <slider v-model:modelValue="formInputs.will_power" :returnNumber="true" :options="sliderWillPower"> </slider>
            </div>
        </div>

        <div class="row form-group mt-5">
            <div class="col-12">
                <label>What are your health objectives?</label>
                <Multiselect v-model="formInputs.health_objectives" :options="HealthObjectives" mode="tags" valueProp="id" label="objective" />
            </div>
        </div>

        <div class="row form-group mt-5">
            <div class="col-12">
                <label>Do you have any of the following diseases?</label>
                <checkbox @update:checked="checkedGout">Gout or any other Rheumatoid Arthritis</checkbox>
                <checkbox @update:checked="checkedDiabetes">Diabetes</checkbox>
                <checkbox @update:checked="checkedHighBloodPressure">High Blood Pressure</checkbox>
            </div>
        </div>

        <div v-if="formInputs.gout" class="row form-group mt-5">
            <div class="col-12 alert alert-warning">
                <label>Warning! Some things in this diet may lead to flare-ups. Look for warning signs in the recipes.</label>
                <checkbox @update:checked="checked => formInputs.gout_warning_read = checked">I've read the warning about this diet and Gout/RA</checkbox>
            </div>
        </div>

        <div v-if="formInputs.diabetes" class="row form-group mt-5">
            <div class="col-12 alert alert-warning">
                <label>
                    Warning! Taking diabetes medication or insulin with this diet can cause your blood sugar to get too low. Work things
                    out with your doctor before starting this diet.
                </label>
                <checkbox @update:checked="checked => formInputs.diabetes_warning_read = checked">I've read the warning about this diet and Diabetes</checkbox>
            </div>
        </div>

        <div v-if="formInputs.high_blood_pressure" class="row form-group mt-5">
            <div class="col-12 alert alert-warning">
                <label>
                    Warning! Taking high blood pressure medication with this diet can cause your blood pressure to get too low. Work things
                    out with your doctor before starting this diet.
                </label>
                <checkbox @update:checked="checked => formInputs.high_blood_pressure_warning_read = checked">I've read the warning about this diet and High Blood Pressure</checkbox>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12 text-center">
                <button class="btn btn-primary" :class="{disabled: disableInsert}">{{ AddEdit }} Survey{{ SurveyID ? ' #'+SurveyID : '' }}</button>
            </div>
        </div>

    </form>
</template>
<script>
import { Notification } from "@/components";
import { useToast } from "vue-toastification";
import { Checkbox, Slider } from "@/components/index";
import Multiselect from '@vueform/multiselect';

import apiHGSurvey from '../api/survey';

let FormInputs = () => {
    return {
        users_id: 0,
        will_power: 4,
        health_objectives: [],
        gout: false,
        gout_warning_read: false,
        diabetes: false,
        diabetes_warning_read: false,
        high_blood_pressure: false,
        high_blood_pressure_warning_read: false,
    };
};

export default {
    components: {
        Slider,
        Multiselect,
        Checkbox
    },
    data() {
        return {
            formInputs: FormInputs(),
            sliderWillPower: {
                range: { min: 1, max: 10 },
                step: 1,
                pips: {
                    mode: 'steps',
                    stepped: true,
                    density: 10
                }
            },
            Error: ''
        };
    },
    props: {
        Survey: {
            type: Object,
            default: {}
        },
        InsertNew: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        AddEdit() {
            this.SetFormInputs();
            return this.InsertNew ? 'Insert New' : 'Update';
        },
        SurveyID() {
            return typeof this.Survey.id !== 'undefined' ? this.Survey.id : 0;
        },
        disableInsert() {
            let disable = false;
            if (this.formInputs.gout && !this.formInputs.gout_warning_read) { disable = true; }
            if (this.formInputs.diabetes && !this.formInputs.diabetes_warning_read) { disable = true; }
            if (this.formInputs.high_blood_pressure && !this.formInputs.high_blood_pressure_warning_read) { disable = true; }
            return disable;
        },
        HealthObjectives() {
            return this.$store.getters.HealthGuideSurveys_GetObjectives();
        }
    },
    mounted() {
        this.SetFormInputs();
        this.$store.dispatch('HealthGuideSurveys_GetObjectives');
    },
    methods: {
        SetFormInputs() {
            this.Error = '';
            this.formInputs = this.SurveyID ? this.Survey : FormInputs();
            this.formInputs.users_id = this.formInputs.users_id || this.$store.getters.userGetID();
        },
        checkedGout(checked) {
            this.formInputs.gout = checked;
            if (!checked) { this.formInputs.gout_warning_read = false; }
        },
        checkedDiabetes(checked) {
            this.formInputs.diabetes = checked;
            if (!checked) { this.formInputs.diabetes_warning_read = false; }
        },
        checkedHighBloodPressure(checked) {
            this.formInputs.high_blood_pressure = checked;
            if (!checked) { this.formInputs.high_blood_pressure_warning_read = false; }
        },
        save() {
            this.Error = '';
            if (this.InsertNew)
            {
                apiHGSurvey.Add(this.formInputs).then(res => {
                    let Data = res.data;
                    Data.health_objectives = this.formInputs.health_objectives;
                    this.$store.dispatch('HealthGuideSurveys_FindByUser', this.$store.getters.userGetID());
                    this.$emit('CloseSurveyModal');
                    this.formInputs = FormInputs();
                    this.NotifyUser('Survey Added Successfully!', 'success');
                }).catch(e => {
                    this.processErrors(e.response.data.errors, e.response.status);
                });
            }
            else
            {
                apiHGSurvey.Update(this.Recipe.id, this.formInputs).then(res => {
                    this.$store.dispatch('HealthGuideSurveys_Update', res.data);
                    this.$emit('CloseSurveyModal');
                    this.formInputs = FormInputs();
                    this.NotifyUser('Survey Updated Successfully!', 'success');
                }).catch(e => {
                    this.processErrors(e.response.data.errors, e.response.status);
                });
            }
        },
        processErrors(Errors, Status) {
            let i = 0;
            if (Status === 422)
            {
                for (let x in Errors)
                {
                    this.Error += (i?'<br>':'')+Errors[x].join('<br>');
                    i++;
                }
            }
        },
        NotifyUser(text, type) {
            const toast = useToast();
            const icon = "now-ui-icons ui-1_bell-53";
            const content = {
                component: Notification,
                props: { icon, text, type },
            };
            toast(content, {
                hideProgressBar: true,
                icon: false,
                closeButton: false,
                position: 'top-right',
            });
        },
    },
    watch: {
    }
};
</script>
<style lang="scss">
#formHealthGuideSurvey {
    .row > div > label { font-weight: bold; }
}
</style>
